import Document from './document.model';

export default class DocumentHolder {

    constructor() {
        this.document = new Document();
    }
}